(function() { module.exports = window["Player"]; }());